/**
 * Single source of truth for all pricing default values.
 * Used by server services, client hooks, page SSR, and admin forms.
 *
 * These defaults apply when DB has NULL or no pricing policy exists.
 * Admin can override all values via /admin/billing/pricing.
 */
export const PRICING_DEFAULTS = {
  storyReservation: 3,
  storyAnalysisReservation: 5,
  blockTextReservation: 1,
  blockAudioReservation: 5,
  assemblyFixed: 0,
  rates: {
    llm: { tokensPer10K: 1 },
    tts: { tokensPerK: 5 },
    assembly: { fixed: 0 },
    imagen: { tokensPerImage: 8 },
  },
  // Legacy fields (backward compat)
  textPerK: 1,
  audioPerK: 5,
} as const;
